import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { OverPaidAgingIncomingInvoiceTodoFormContainerProps } from "models/propTypes/incomingInvoicePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { FormFieldConstants } from "utils/constants";
import { AgingIncomingInvoiceOverPaidActions } from "models/enums/incomingInvoice";
import { IncomingInvoiceFormTypes } from "models/formTypes";
//#endregion
//#region components
import OverPaidAgingIncomingInvoiceTodoForm from "./overPaidAgingIncomingInvoiceTodoForm";
//#endregion
import * as Yup from "yup";

const OverPaidAgingIncomingInvoiceTodoFormContainer: ForwardRefRenderFunction<
  FormHandles,
  OverPaidAgingIncomingInvoiceTodoFormContainerProps
> = (props, ref) => {
  const initialValues: IncomingInvoiceFormTypes.OverPaidAgingInvoiceTodo = { explanation: "" };

  const validationSchema = Yup.object<IncomingInvoiceFormTypes.OverPaidAgingInvoiceTodo>({
    action: Yup.number().required(TranslationKeys.Validations.Required),
    explanation: Yup.string().when(
      [FormFieldConstants.IncomingInvoice.OverPaidAgingInvoiceTodo.Action],
      ([action], schema: Yup.StringSchema) =>
        (action === AgingIncomingInvoiceOverPaidActions.OverpaidInfoSupplied &&
          schema.required(TranslationKeys.Validations.Required)) ||
        schema
    ),
    files: Yup.array().of(
      Yup.object<UploadedFile>({
        contentType: Yup.string(),
        fileName: Yup.string(),
        fileSize: Yup.number(),
        data: Yup.string(),
      })
    ),
  });

  return (
    <OverPaidAgingIncomingInvoiceTodoForm
      ref={ref}
      {...props}
      defaultValues={initialValues}
      validationSchema={validationSchema}
    />
  );
};

export default forwardRef(OverPaidAgingIncomingInvoiceTodoFormContainer);
